import { Typography } from 'antd'
import styled from 'styled-components'

import { colours } from '@qflow/theme'
import { ClickableLink, ColourButton } from 'portal/lib/primitives'

export const TableWrapper = styled.div`
  background-color: ${colours.WHITE};
  border-radius: 10px;
  padding: 0.5rem 1.25rem 1.25rem 1.25rem;
  margin-top: 1rem;
  box-shadow: 0px 1px 3px 0px #00000026;

  .ant-table-wrapper .ant-table .ant-table-footer {
    padding: 0;
  }
`
export const TableFooter = styled.div`
  position: relative;
  width: 99%;
`
export const ZeroRecordsFooter = styled.div`
  display: flex;
  justify-content: center;
  color: ${colours.BATTLESHIP_GREY};
`
export const ButtonContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0.75rem;
`
export const BTTButton = styled(ColourButton.Basic)`
  line-height: 1;
  width: auto;
`
export const StyledClickableLink = styled(ClickableLink)`
  height: 32px;
  width: 32px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: ${colours.TEAL};
  }
`
export const CapitalisedText = styled(Typography.Text)`
  text-transform: capitalize;
`
export const ShowingAlertsText = styled.div`
  margin: 1rem 0.5rem 0;
  text-align: center;
`
